import { FontStyles } from "../../utils/font-styles";
import { CharteredLogo } from "../chartered-logo.tsx";

export interface HeaderProps {
  firmName: string;
  firmSlogan: string;
}

export const Header = (props: HeaderProps) => {
  return (
    <header className="flex flex-col gap-4">
      <div className="flex items-center justify-start md:justify-between flex-wrap-reverse gap-4">
        <h1
          className={`${FontStyles.h3} leading-none md:leading-none text-north-sea font-medium basis-full md:basis-auto`}
        >
          {props.firmName}
        </h1>
        <CharteredLogo />
      </div>

      <h2 className={FontStyles.h6}> {props.firmSlogan}</h2>
    </header>
  );
};
